function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4272 5.62536C37.4272 7.80607 35.6357 9.57592 33.4284 9.57592C31.2211 9.57592 29.4297 7.80607 29.4297 5.62536C29.4297 3.44466 31.2211 1.6748 33.4284 1.6748C35.6357 1.6748 37.4272 3.44466 37.4272 5.62536Z",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4272 26.1742C37.4272 28.3549 35.6357 30.1248 33.4284 30.1248C31.2211 30.1248 29.4297 28.3549 29.4297 26.1742C29.4297 23.9935 31.2211 22.2236 33.4284 22.2236C35.6357 22.2236 37.4272 23.9935 37.4272 26.1742Z",
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99747 16.2855C9.99747 18.4662 8.20604 20.2361 5.99874 20.2361C3.79143 20.2361 2 18.4662 2 16.2855C2 14.1048 3.79143 12.335 5.99874 12.335C8.20604 12.335 9.99747 14.1048 9.99747 16.2855Z",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8338 26.1734C26.9864 26.1734 25.8328 26.1734 25.3709 26.1734C22.8457 26.1734 20.5444 24.7394 19.4568 22.4856C18.859 21.2451 19.2408 22.0372 18.741 21.0021C17.3514 18.1202 14.4084 16.2852 11.1754 16.2852C11.0654 16.2852 10.7895 16.2852 10.3477 16.2852",
  strokeWidth: 3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8338 5.625C26.9864 5.625 25.8328 5.625 25.3709 5.625C22.8457 5.625 20.5444 7.05905 19.4568 9.31285C18.859 10.5533 19.2408 9.76124 18.741 10.7963C17.3514 13.6782 14.4084 15.5133 11.1754 15.5133C11.0654 15.5133 10.7895 15.5133 10.3477 15.5133",
  strokeWidth: 3
});

const SvgGitIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gitIcon.f5ddce6d.svg";
export { ForwardRef as ReactComponent };